import { render, staticRenderFns } from "./NavConfig.vue?vue&type=template&id=24da71a3&scoped=true"
import script from "./NavConfig.vue?vue&type=script&lang=js"
export * from "./NavConfig.vue?vue&type=script&lang=js"
import style0 from "./NavConfig.vue?vue&type=style&index=0&id=24da71a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da71a3",
  null
  
)

export default component.exports